import { render, staticRenderFns } from "./PortalUserListPage.vue?vue&type=template&id=21838428&"
import script from "./PortalUserListPage.vue?vue&type=script&lang=ts&"
export * from "./PortalUserListPage.vue?vue&type=script&lang=ts&"
import style0 from "./PortalUserListPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports